import React, { useEffect } from 'react';
import { useLocation, NavLink  } from 'react-router-dom'; 
import Highlights from'../Component/Highlights' 
import LazyLoad from 'react-lazyload'
const Header = () => {
    const { pathname } = useLocation(); 
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
        <>
        
        <div className="header multbg padded-sec">
       
        <div className="logo">
            <NavLink to="/">
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/logo.png" alt="St. Francis Xavier School" className="img-fluid"/></LazyLoad></NavLink>
        </div>
        <div className="header-nav">
        <Highlights/>
            <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav">
                    <li className="nav-item active"> <NavLink  className="dropdown-item" to="/">Home</NavLink></li>
                     <li className="nav-item dropdown"> 
                       <div className="nav-link"  data-bs-toggle="dropdown">  School </div>  
                        <ul className="dropdown-menu fade-up listheader"> 
                        <li><NavLink className="dropdown-item" to="/AboutUs">About School</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/SchoolInformation">School Information</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/Aims">Aims & Objectives</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/OurPhilosophy">Our Philosophy</NavLink> </li>
                        <li><NavLink className="dropdown-item" to="/CampusInformation">Campus Information</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/SchoolStrength">School Strength</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/Infrastructure">Facilities & Infrastructure</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/OurPrinciples">Our Principles</NavLink></li>
                        <li><NavLink className="dropdown-item" target="_blank" to="https://www.cbse.gov.in/">CBSE Website</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/ManagingCommittee"> School Management </NavLink></li>
                        <li><NavLink className="dropdown-item" to="/SchoolCabinet">School Cabinet </NavLink></li>
                        <li><NavLink className="dropdown-item" to="/StaffList"> Staff List</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/Syllabus"> Syllabus</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/Circular"> Circular</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/Datesheet"> Datesheet</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/HomeWork"> Homework</NavLink></li> 
                        </ul>   
                    </li> 
                    <li className="nav-item dropdown">
                      <div className="nav-link" data-bs-toggle="dropdown">Prospectus
                      </div>  
                         <ul className="dropdown-menu fade-up">
                         <li><NavLink className="dropdown-item" to="/FeeStructure"> Fee Structure</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/JuniorWing">Junior Wing</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/SeniorWing"> Senior Wing</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/SpecialFeatures">Special Features</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/Academics">Academics</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/AdmissionWithdrawals">Admission & Withdrawals</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/Discipline">Discipline</NavLink></li>
                         <li><NavLink className="dropdown-item" to="/EvaluationScholarships">Evaluation & Scholarships</NavLink></li>
                         <li><NavLink className="dropdown-item" to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/booklist.pdf" target="_blank">Booklist</NavLink></li>
                        </ul> 
                    </li>
                    <li className="nav-item dropdown"> 
                      <div className="nav-link"  data-bs-toggle="dropdown">                Mandatory Public Disclosure </div>  
                      <ul className="dropdown-menu fade-up listheader"> 
                              <li><NavLink className="dropdown-item" to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/Mandatory-Public-Disclosure.pdf" target="_blank"> Mandatory Public
                              Disclosure</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/GeneralInformation"> General Information</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/AffiliationCertificate"> Affiliation Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/RegistrationCertificate">Society Registration Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/Noc"> NOC By State Govt</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/RecognitionCertificate"> Recognition Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/BuildingSafetyCertificate"> Building Safety Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/FireSafetyCertificate"> Fire Safety Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/SchoolFeeStructure"> Fee Structure of Schools</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/AcademicCalendar"> Annual Academic Calendar</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/Smc"> List of SMC</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/PTAMembers"> List of PTA Members</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/TeachingStaff"> List of Teaching Staff</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/ResultAnalysis"> Last 3 Year Result of Board</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/AffiliationSelfDeclaration">Affiliation Self Declaration</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/SchoolInfrastructure">School Infrastructure</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/HealthSanitationCertificate"> Water, Health & Sanitation
                              Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/SchoolLeavingCertificate"> School Leaving Certificate</NavLink></li> 
                              <li><NavLink className="dropdown-item" to="/Minority">Minority Certificate</NavLink></li> 
                      </ul>   
                      </li>   
                    
                    <li className="nav-item dropdown">
                       <div className="nav-link"  data-bs-toggle="dropdown"> Gallery </div>  
                          <ul className="dropdown-menu fade-up">
                          <li><NavLink className="dropdown-item" to="/Gallery">Photo Gallery</NavLink></li>
                          <li><NavLink className="dropdown-item" to="/VideoGallery"> Video Gallery</NavLink></li>
                          <li><NavLink className="dropdown-item" to="/MediaGallery">Media Gallery </NavLink></li>
                          <li><NavLink className="dropdown-item" to="/VirtualTour">Virtual Tour </NavLink></li>
                        </ul>  
                    </li>
                    <li className="nav-item dropdown"> 
                      <div className="nav-link"  data-bs-toggle="dropdown"> Message</div>  
                           <ul className="dropdown-menu fade-up">
                           <li><NavLink className="dropdown-item" to="/ManagerMessage">Manager's Message</NavLink></li>
                           <li><NavLink className="dropdown-item" to="/PrincipalMessage"> Principal's Message</NavLink></li>
                           <li><NavLink className="dropdown-item" to="/HeadGirlMessage">Head Girl's Message </NavLink></li>
                           <li><NavLink className="dropdown-item" to="/HeadBoyMessage">Head Boy's Message </NavLink></li>
                        </ul>  
                    </li>  
                    <li className="nav-item dropdown"> 
                      <div className="nav-link"  data-bs-toggle="dropdown">Achievements</div>  
                           <ul className="dropdown-menu fade-up">
                           <li><NavLink className="dropdown-item" to="/OurAchievements">Our Achievements</NavLink></li>
                           <li><NavLink className="dropdown-item" to="/TopperX">Toppers X</NavLink></li>
                           <li><NavLink className="dropdown-item" to="/TopperXII">Toppers XII </NavLink></li>
                        </ul>  
                    </li>  
                    <li className="nav-item dropdown"> 
                      <div className="nav-link"  data-bs-toggle="dropdown">Contact Us</div>  
                           <ul className="dropdown-menu fade-up">
                              <li><NavLink className="dropdown-item" to="/MailUs">Mail Us</NavLink></li>
                              <li><NavLink className="dropdown-item" to="/GuestBook">Guest Book</NavLink></li>
                              <li><NavLink className="dropdown-item" to="/SiteMap">Site Map</NavLink></li>
                           </ul>  
                    </li>   
                </ul>
                </div> 
           </nav>
        </div>
        
    </div>
    </>
  )
}

export default Header
